<template>
  <div>
      <div class="single-ticket--row" v-if="isPossibleWinBTVisible()">
        <span>{{$t('win_bt')}}:</span>
        <span class="value-field">{{getPossibleWinValue(ticket, false)}}</span>
      </div>
      <div class="single-ticket--row" v-if="isPossibleWinBTVisible()">
        <span>{{$t('win_at')}}:</span>
        <span class="value-field">{{getPossibleWinValue(ticket)}}</span>
      </div>
      <div class="single-ticket--row" v-if="!isPossibleWinBTVisible()">
        <span>{{$t('win')}}:</span>
        <span class="value-field">{{getPossibleWinValue(ticket)}}</span>
      </div>
  </div>
</template>

<script>
import NumberFormat from '@/mixins/NumberFormat'
import LanguageHelper from '@/mixins/LanguageHelper'
export default {
  mixins: [NumberFormat, LanguageHelper],
  props: {
    ticket: {
      type: Object,
      required: true
    }
  },
  methods: {
    getPossibleWinValue (ticket, isPossibleAT = true) {
      if (ticket.Status === 1) {
        if (isPossibleAT) {
          return this.format(ticket.PossibleWinAT)
        } else {
          return this.format(ticket.PossibleWinBT)
        }
      }
      return this.format(0.00)
    },
    isPossibleWinBTVisible: function () {
      return this.ticket.PossibleWinAT !== this.ticket.PossibleWinBT
    },
    format: function (value) {
      return this.formatNumber(value, this.getLanguageCodeForNumbers(), 2)
    }
  }
}
</script>
